const NAV_GROUPS = [
  {
    id: 'home', title: 'Home', isLink: true, pageKey: 'home',
  },
  { id: 'digitize', title: 'Digitize', isLink: false },
  { id: 'enhance', title: 'Enhance', isLink: false },
  { id: 'create', title: 'Create', isLink: false },
  { id: 'digitize_fl', title: 'Digitize FL', isLink: false },
  { id: 'services', title: 'Services', isLink: false },
  { id: 'info', title: 'Info', isLink: false },
];

export default NAV_GROUPS;
